import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { useHistory, useParams } from "react-router";

import ButtonBack from "newApp/components/ButtonBack";
import MainLayout from "newApp/components/layouts/MainLayout";
import Button from "newApp/kit/components/Button";
import ButtonsContainer from "newApp/kit/components/ButtonsContainer";
import FlexColumn from "newApp/kit/components/FlexColumn";
import CategoryForm from "newApp/components/ShopCategoryForm";
import H1 from "newApp/kit/components/H1";

import { URL_SHOP_CATEGORIES } from "newApp/routing/urls";

import { CategoryEditPageStore } from "newApp/stores/pages/shop/categories/CategoryEditPageStore";
import LoaderSpinner from "newApp/kit/components/LoaderSpinner";

const store = new CategoryEditPageStore();

const CategoriesCreatePage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { push } = useHistory();

  useEffect(() => {
    store.init(id);

    return () => store.reset();
  }, [id]);

  const saveCategoryHandler = () => {
    store.validateAndSave(id).then(() => push(URL_SHOP_CATEGORIES));
  };

  return (
    <MainLayout>
      <H1>Редактирование рубрики</H1>
      {store.isLoading ? (
        <LoaderSpinner />
      ) : (
        <FlexColumn>
          <ButtonBack url={URL_SHOP_CATEGORIES}>
            Назад к списку рубрик
          </ButtonBack>
          <CategoryForm {...store.categoryForm} />
          <ButtonsContainer>
            <Button onClick={saveCategoryHandler}>Сохранить</Button>
            <Button
              onClick={() => push(URL_SHOP_CATEGORIES)}
              variant="secondary"
            >
              Отменить
            </Button>
          </ButtonsContainer>
        </FlexColumn>
      )}
    </MainLayout>
  );
};

export default observer(CategoriesCreatePage);
